import React, {useContext} from 'react'
import {SettingRoleContext} from "../../context/SettingRoleContext";

function RolesItem(props) {
    const {item, index} = props
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {roleSelected, setRoleSelected, setFilters} = SettingRolePageContext

    const _clickRow = (value) => {
        setRoleSelected([value])
        setFilters({description: ''})
    }

    return (
        <tr className={`RowItem ${roleSelected[0] === item.roleId ? 'active' : ''}`}
            onClick={() => _clickRow(item.roleId)}>
            <td className="itemCol">
                {index + 1}
            </td>
            <td className="itemCol">{item.tenantName || ''}</td>
            <td className="itemCol">{item.roleName || ''}</td>
        </tr>
    )
}

export default RolesItem
